import React, { useState, useEffect, useRef } from 'react';
import { useSwipeable } from 'react-swipeable';
import withAppState from '../mobx/withAppState';
import xmark from '../assets/img/xmark.svg'

const SwipeableContainer = props => {
  const { customClass = null, customInnerClass = null } = props;
  const [isOpen, setIsOpen] = useState(props.slideUpModal);
  const [isInnerScrolled, setInnerScrolled] = useState(false);

  const innerModal = useRef(null);  


  const handlers = useSwipeable({ 
    onSwiping: eventData => {
      if (eventData.dir === 'Down' && !isInnerScrolled) {
        props.setSwipeable(true);
        props.setDragDownModal(eventData.deltaY);
          if (eventData.deltaY > (innerModal.current.clientHeight / 2 || window.innerHeight / 2)) {
            console.log('swiped down, closing modal', innerModal.current.clientHeight);
            setTimeout(() => {
              props.setDragDownModal(innerModal.current.clientHeight);
              props.handleModalCancel();
            }, 0);
        }
      }
    },
    onSwiped: eventData => {
      props.setSwipeable(false);
      if (eventData.dir === 'Down' && eventData.deltaY < (innerModal.current.clientHeight / 2 || window.innerHeight / 2)) {
        props.setDragDownModal(0);
        setIsOpen(!isOpen);
      }
    },
    trackTouch: true,
    trackMouse: false,
  });

  var dragDownHeight = {
    bottom: -props.swipeableModalPosition + 'px',
    touchAction: 'pan-y',
  };

  const ScrollInnerContainer = (e)=> {
  if (e.target.scrollTop > 0) {
      setInnerScrolled(true);
    } else {
      setInnerScrolled(false);
    }
  }
  
  useEffect(() => {
    document.body.classList.toggle('modal-open', props.slideUpModal);
  }, [props.slideUpModal]);

   
  const appHeight = window.innerHeight;

  return (
    <div  
      aria-labelledby={props.modalAriaTitle}
      aria-describedby={props.modalAriaDescription}
      autoFocus={props.slideUpModal}
      style={props.slideUpModal && !isInnerScrolled ? dragDownHeight  : null}
      {...handlers}
      className={`modal-slide-up ${props.slideUpModal ? 'active' : 'is-hidden'} ${props.swipeable ? 'is-swipeable' : ''} ${
        props.slideOutAnimation ? 'is-animatingOut' : ''
      } ${customClass ? customClass : ''}`}>
        <div onScroll={ScrollInnerContainer} style={{maxHeight: appHeight * 0.9}} ref={innerModal} className={`modal-slide-up-inner ${customInnerClass ? customInnerClass : ''}`}>
          <button onClick={() => props.handleModalCancel()} className="modal-close">
            <img alt="null" src={xmark} className="swipeable-close"></img>
          </button>
          <div {...handlers}>
            <div className="slide-draw-bar"></div>
          </div>
          {props.children}
      </div>
    </div>
  );
};

export default withAppState(SwipeableContainer, {
  mobXProps: ({ modalActive, swipeable, swipeableModalPosition, slideOutAnimation }) => ({
    modalActive,
    swipeable,
    swipeableModalPosition,
    slideOutAnimation,
  }),
  mobXActions: ({ closeSlideUpModal, setSwipeable, setDragDownModal }) => ({
    closeSlideUpModal,
    setSwipeable,
    setDragDownModal,
  }),
});
